type EventListener = (data?: unknown) => void;

class EventEmitter {
	private listeners: { [key: string]: EventListener[] } = {};

	on(event: string, callback: EventListener) {
		if (!this.listeners[event]) {
			this.listeners[event] = [];
		}
		this.listeners[event].push(callback);
	}

	emit(event: string, data?: unknown) {
		if (!this.listeners[event]) {
			return;
		}
		this.listeners[event].forEach((callback) => {
			callback(data);
		});
	}

	off(event: string, callback: EventListener) {
		if (!this.listeners[event]) {
			return;
		}
		this.listeners[event] = this.listeners[event].filter(
			(cb) => cb !== callback,
		);
	}
}

export const AUTH_EVENTS = {
	UNAUTHORIZED: "unauthorized",
} as const;

export const authEmitter = new EventEmitter();
